import { Box } from "@mui/material";
import styled from "styled-components";
import { SubSectionContainerText } from "components/SubSection/SubSection.styled";
import { ImageElement, ImageContainer } from "components/Image/Image.styled";
import { ButtonContainer } from "components/Button/ActionButton/ActionButton.styled";
import { Highlight } from "components/Hightlight/Hightlight.style";

export const HowWeCanHelpBannerContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 152px 0 0 0;
  font-weight: 400;
  margin-bottom: 120px;

  @media (max-width: 1170px) {
    padding: 72px 0px 32px 0px;
    margin-bottom: 0px;
    & {
      justify-content: center;
    }
    & ${ButtonContainer} {
      max-width: none;
    }
  }
`;
export const HowWeCanHelpBannerParagraph = styled(Box)`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  max-width: 518px;
`;
export const HowWeCanHelpBannerParagraphHeader = styled(Box)`
  font-size: 72px;
  font-stretch: expanded;
  letter-spacing: -1px;
  color: ${(props) => props?.theme.colors?.dark};

  @media (max-width: 1170px) {
    font-size: 28px;
    width: 200px;
  }
`;
export const HowWeCanHelpBannerParagraphText = styled(Box)`
  color: ${(props) => props?.theme.colors?.headerColor};
  & ${SubSectionContainerText} {
    margin: 12px 0px 34px 0;
  }

  & ${Highlight} {
    font-stretch: normal;
  }

  @media (max-width: 1170px) {
    & ${SubSectionContainerText} {
      font-size: 16px;
      line-height: 150%;
      margin: 10px 0px 24px 0px;
      letter-spacing: 0px;
    }
    & ${Highlight} {
      line-height: 150%;
    }
  }
`;

export const HowWeCanHelpBannerParagraphActions = styled(Box)`
  display: flex;
  flex-wrap: nowrap;
  gap: 27px;
  padding-bottom: 10px;
  padding-right: 10px;

  & a {
    flex-shrink: 0;
    gap: 6px;
  }

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 16px;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 8px;
    padding-right: 0px;
    padding-bottom: 24px;
  }
`;

export const HowWeCanHelpBannerImage = styled(Box)`
  background-image: url(${(props) => props.src});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  border-radius: 32px;
  width: 618px;
  height: 492px;

  @media (max-width: 1170px) {
    & ${ImageContainer}, & ${ImageElement}, & img {
      height: auto;
      width: 100vw;
      margin: 0 0 -2px 0;
      border-radius: 0;
    }
  }

  @media (max-width: 600px) {
    width: 100vw;
    height: auto;
    padding-top: 80%;
    margin: 0;
    border-radius: 16px;
  }
`;
export const Bold = styled.span`
  font-weight: 800;
  font-stretch: expanded;
`;
